var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import { FamilyRole, StorageKeys, useGetPersonApi, useIsCountryCompleted, useIsMemberRegistryCompleted, useIsPlanCreated, useIsUserAuthenticated, useIsWalkThroughCompleted, } from '@planter/common';
import * as React from 'react';
import Loader from '../../components/Loader';
import { useInAppPurchase } from '../../hooks/useInAppPurchase';
import { UserRole } from '../../models';
import { EntitlementState } from '../../services/InAppPurchase/types';
import { useCustomerData } from '../CustomerDataProvider';
import { isAppReady as getIsAppReady, resolveUserRole, } from './resolveUserRole';
import { resolveEntitlementState } from './resolveEntitlementState';
export var UserRoleContext = React.createContext({
    setUserRole: function () {
        throw new Error('setUserRole is not yet implemented');
    },
    userRole: UserRole.Anonymous,
});
export var UserRoleProvider = function (_a) {
    var _b, _c, _d;
    var children = _a.children;
    var _e = React.useState(), userRole = _e[0], setUserRole = _e[1];
    var coupon = localStorage.getItem(StorageKeys.COUPON_CODE_KEY);
    var b2bCoupon = localStorage.getItem(StorageKeys.B2B_CODE_KEY);
    var hasRedeemCode = Boolean(coupon || b2bCoupon);
    var isWalkThroughCompleted = useIsWalkThroughCompleted().isWalkThroughCompleted;
    var isAuthenticated = useIsUserAuthenticated().isAuthenticated;
    var isCountryCompleted = useIsCountryCompleted().isCountryCompleted;
    var isMemberRegistryCompleted = useIsMemberRegistryCompleted().isMemberRegistryCompleted;
    var isPlanCreated = useIsPlanCreated().isPlanCreated;
    // Usa i dati condivisi dal CustomerDataProvider invece di fare la chiamata API
    var customer = useCustomerData().customer;
    var person = useGetPersonApi(customer === null || customer === void 0 ? void 0 : customer.personId).data;
    var _f = React.useState(false), userPaymentNeeded = _f[0], setUserPaymentNeeded = _f[1];
    var familyId = (_b = customer === null || customer === void 0 ? void 0 : customer.Person) === null || _b === void 0 ? void 0 : _b.familyId;
    var isAppReady = getIsAppReady({
        isWalkThroughCompleted: isWalkThroughCompleted,
        isAuthenticated: isAuthenticated,
        isCountryCompleted: isCountryCompleted,
        isMemberRegistryCompleted: isMemberRegistryCompleted,
    });
    var entitlementStateChange = React.useCallback(function (entitlementState) {
        setEntitlementState(entitlementState);
    }, []);
    var _g = React.useState(EntitlementState.none), entitlementState = _g[0], setEntitlementState = _g[1];
    var _h = useInAppPurchase({
        onEntitlementChange: entitlementStateChange,
    }), initSdk = _h.initSdk, checkEntitlements = _h.checkEntitlements;
    React.useEffect(function () {
        var _a, _b;
        // @TENANT_BYPASS: Verifica che tutti i parametri necessari siano disponibili prima di chiamare initSdk
        // Questo evita errori Qonversion quando i dati non sono ancora completamente caricati dopo il riscatto codice
        if (!(person === null || person === void 0 ? void 0 : person.familyId) ||
            !((_a = person === null || person === void 0 ? void 0 : person.Customer) === null || _a === void 0 ? void 0 : _a.email) ||
            !((_b = person === null || person === void 0 ? void 0 : person.Customer) === null || _b === void 0 ? void 0 : _b.id)) {
            return;
        }
        var familyId = person.familyId;
        var email = person.Customer.email;
        var customerId = person.Customer.id;
        // Se Qonversion non risponde (giù/500/503) il fallback è EntitlementState.none e l'accesso resta deciso dal nostro BE (paidOnDb)
        resolveEntitlementState(function () { return initSdk(familyId, email, customerId); }, checkEntitlements).then(setEntitlementState);
    }, [
        checkEntitlements,
        initSdk,
        (_c = person === null || person === void 0 ? void 0 : person.Customer) === null || _c === void 0 ? void 0 : _c.email,
        (_d = person === null || person === void 0 ? void 0 : person.Customer) === null || _d === void 0 ? void 0 : _d.id,
        person === null || person === void 0 ? void 0 : person.familyId,
        person === null || person === void 0 ? void 0 : person.id,
    ]);
    React.useEffect(function () {
        var checkPaymentStatus = function () { return __awaiter(void 0, void 0, void 0, function () {
            var familyLeaderSubscription, familyLeaderEntitlement, paidOnDb, paidOnQonversion, needsPayment;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                if (!isAppReady ||
                    !((_b = (_a = customer === null || customer === void 0 ? void 0 : customer.Person) === null || _a === void 0 ? void 0 : _a.Family) === null || _b === void 0 ? void 0 : _b.Person) ||
                    !isCountryCompleted ||
                    !isMemberRegistryCompleted) {
                    setUserPaymentNeeded(false);
                    return [2 /*return*/];
                }
                familyLeaderSubscription = (_d = (_c = customer.Person.Family.Person.find(function (person) {
                    return person.familyRole === FamilyRole.FAMILY_LEADER;
                })) === null || _c === void 0 ? void 0 : _c.Customer) === null || _d === void 0 ? void 0 : _d.Subscription;
                familyLeaderEntitlement = familyLeaderSubscription === null || familyLeaderSubscription === void 0 ? void 0 : familyLeaderSubscription.status;
                paidOnDb = familyLeaderEntitlement === 'AUTHORIZED';
                paidOnQonversion = entitlementState === EntitlementState.active;
                needsPayment = !paidOnDb && !paidOnQonversion;
                setUserPaymentNeeded(needsPayment);
                return [2 /*return*/];
            });
        }); };
        checkPaymentStatus();
    }, [
        entitlementState,
        familyId,
        customer,
        isAppReady,
        isCountryCompleted,
        isMemberRegistryCompleted,
    ]);
    React.useEffect(function () {
        var role = resolveUserRole({
            isWalkThroughCompleted: isWalkThroughCompleted,
            isAuthenticated: isAuthenticated,
            isCountryCompleted: isCountryCompleted,
            isMemberRegistryCompleted: isMemberRegistryCompleted,
            isPlanCreated: isPlanCreated,
            hasRedeemCode: hasRedeemCode,
            hasPerson: Boolean(person),
            userPaymentNeeded: userPaymentNeeded,
        });
        // undefined finché i dati non sono pronti: si resta sul Loader
        if (!role) {
            return;
        }
        setUserRole(role);
    }, [
        isWalkThroughCompleted,
        isAuthenticated,
        isCountryCompleted,
        isMemberRegistryCompleted,
        isPlanCreated,
        userPaymentNeeded,
        hasRedeemCode,
        person,
    ]);
    return (_jsx(UserRoleContext.Provider, { value: { userRole: userRole || UserRole.Anonymous, setUserRole: setUserRole }, children: userRole ? children : _jsx(Loader, {}) }));
};
